import { render, staticRenderFns } from "./cabinet-verification.vue?vue&type=template&id=6bc3a962&scoped=true&"
import script from "./cabinet-verification.vue?vue&type=script&lang=js&"
export * from "./cabinet-verification.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-verification.vue?vue&type=style&index=0&id=6bc3a962&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3a962",
  null
  
)

export default component.exports